module.exports = __webpack_public_path__ + "img/band_text.e074c52f.jpg";